// Component
import Toggle from "../../button/Toggle";
import NumberInput from "../../input/NumberInput";
import Select from "../../input/Select";

// PrimeReact
import { Button } from "primereact/button";
import { toast } from "react-toastify";

const OwnerSelectField = ({
  ownerField,
  index,
  loadingOwners,
  owners,
  errorsEdit,
  formEdit,
  handleInputChange,
  onChangeHolder,
  getFormErrorMessage,
  handleAddOwner,
  handleRemoveOwner,
  canRemove,
  handleOwnerChange
}) => {
  if (!formEdit || !formEdit.control) {
    console.error("formEdit ou control não está definido.");
    return null;
  }

  return (
    <div className="row ">
      <div className="col-md-4 ">
        <Select
          name={`ownerFields.${index}.user_id`}
          label={loadingOwners ? "Carregando..." : "Proprietário"}
          disabled={loadingOwners}
          errors={errorsEdit}
          control={formEdit.control}
          value={formEdit.getValues(`ownerFields.${index}.user_id`)}
          options={
            owners &&
            owners.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          }
          onChange={(e) => {
            handleOwnerChange(e, index);
            console.log("Selected owner:", e);
          }}
        />
      </div>
      <div className="col-md-4 ">
        <NumberInput
          name={`ownerFields.${index}.percentage`}
          suffix="%"
          placeholder="0%"
          max={100}
          min={0}
          onBlur={() => handleInputChange(index)}
          errors={errorsEdit}
          minFractionDigits={2}
          maxFractionDigits={2}
          control={formEdit.control}
          label="% Participação"
          value={formEdit.getValues(`ownerFields.${index}.percentage`)}
          rules={{
            min: { value: 0, message: "Mínimo é 0%" },
            validate: (val) => val <= 100 || "Máximo é 100%",
          }}
        />
      </div>
      <div className="col-md-4  d-flex gap-2 mt-4 ">
        <Toggle
          name={`ownerFields.${index}.holder`}
          checked={!!formEdit.getValues(`ownerFields.${index}.holder`)}
          control={formEdit.control}
          onLabel="Titular"
          offLabel="Titular"
          onChange={() => onChangeHolder(index)}
          getFormErrorMessage={getFormErrorMessage}
        />
        {index > 0 && canRemove && (
          <Button
            type="button"
            icon="pi pi-minus"
            className="p-button-danger p-button-sm p-button-rounded p-button-outlined"
            onClick={handleRemoveOwner}
            title="Remover proprietário"
            tooltip="Remover proprietário"
            tooltipOptions={{ position: "top" }}
          />
        )}
        {index === 0 && (
          <Button
            type="button"
            icon="pi pi-plus"
            className="p-button-success p-button-sm p-button-rounded p-button-outlined"
            onClick={handleAddOwner}
            title="Adicionar proprietário"
            tooltip="Adicionar proprietário"
            tooltipOptions={{ position: "top" }}
          />
        )}
      </div>
    </div>
  );
};

export default OwnerSelectField;
